import React, { Component } from 'react';
import { AuthConsumer } from 'react-check-auth';
import { Route, Switch, Link } from 'react-router-dom';


class HomeButton extends Component {
  render() {
    return (
      <AuthConsumer>
        {({userInfo}) => {
          return (
            <Switch>
              <Route path="/login">
              </Route>
              <Route path="/dashboard">
                <Link to="/">
                  <button className={this.props.className}>Home</button>
                </Link>
              </Route>
              <Route path="/">
                <Link to={ userInfo ? '/dashboard' : '/' }>
                  <button className={this.props.className}>{ userInfo ? 'Dashboard' : 'Home' }</button>
                </Link>
              </Route>
            </Switch>
          );
        } }
      </AuthConsumer>
    );
  }
}

export default HomeButton;



// WEBPACK FOOTER //
// ./src/HomeButton.jsx